import React from "react";
import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
import { object, string } from "yup";
import AssignDialogForm from "./AssignDialogForm";
import { useAddAssignQuestionMutation } from "src/services/BatchServices";

type Props = {
  onClose: () => void;
  batchData: any;
};

export type AssignDialogFormValuesType = {
  assigment: any;
  tagId: any;
  searchValue: string;
  complexity: any;
  order: string;
};

const AssignDialogFormWrapper = ({ onClose, batchData }: Props) => {
  const [addAssign, addAssignInfo] = useAddAssignQuestionMutation();

  // Form Initial Values
  const initialValues: AssignDialogFormValuesType = {
    assigment: "",
    tagId: "",
    searchValue: "",
    complexity: "",
    order: "",
  };

  // Validation Schema
  const validationSchema = object().shape({
    searchValue: string(),
  });

  // Handle Submit
  const handleSubmit = (
    values: AssignDialogFormValuesType,
    { setSubmitting, resetForm }: FormikHelpers<AssignDialogFormValuesType>
  ) => {
    setTimeout(() => {
      resetForm();
    }, 1000);
  };

  return (
    <Dialog
      PaperProps={{
        sx: {
          width: "100%",
          minWidth: "90%!important",
          minHeight: "90%!important",
          maxHeight: "90%!important",
          maxWidth: "90%!important",
        },
      }}
      open
    >
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            <AssignDialogForm
              batchData={batchData}
              addAssign={addAssign}
              addLoading={addAssignInfo?.isLoading}
              formikProps={formikProps}
              onClose={onClose}
            />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default AssignDialogFormWrapper;
